import { render, staticRenderFns } from "./PortalNoteDrayage.vue?vue&type=template&id=2162d3e8&scoped=true"
import script from "./PortalNoteDrayage.vue?vue&type=script&lang=js"
export * from "./PortalNoteDrayage.vue?vue&type=script&lang=js"
import style0 from "./PortalNoteDrayage.vue?vue&type=style&index=0&id=2162d3e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2162d3e8",
  null
  
)

export default component.exports